// extracted by mini-css-extract-plugin
export var link = "_sn-0";